import axios from 'axios';
const renderEnv = process.env.RENDER_ENV; // 渲染环境：client/server


export const request = userConf => {
    return new Promise((resolve, reject) => {
        const conf = Object.assign({
            url: '',
            data: {},
            method: 'get'
        }, userConf);
        const onSuccess = (data, cb) => {
            // const {store, route} = conf;
            // const {processor} = require(`@/pages${route.path}.js`);
            // const storeKey = route.path;

            // // 数据预处理
            // if (renderEnv === 'server') {
            //     if (typeof processor === 'function') {
            //         data = processor(data);
            //     }
            //     // init store
            //     let mutations = {};
            //     Object.keys(data).map(key => {
            //         mutations[`get_${key}`] = (state, v) => {
            //             state.key = v;
            //         };
            //     });
            //     store.registerModule(storeKey, {
            //         state: data,
            //         mutations,
            //         actions: {},
            //         getters: {}
            //     });
            // }
            cb(data);
        };

        const onFail = (data, cb) => {
            // toast
            console.error(data.toast || data.statusText);
            cb(data);
        };

        // axios
        axios(
            Object.assign(
                {
                    url: conf.url,
                    method: conf.method
                },
                ['post', 'put', 'patch'].indexOf(conf.method.toLowerCase()) > -1
                    // post/put/patch
                    ? {
                        data: conf.data
                    }
                    // get
                    : {
                        params: conf.data
                    }
            )
        ).then(resp => {
            if (resp.status === 200) {
                // 判断请求数据成功
                if (resp.data && resp.data.status === 0) {
                    onSuccess(resp.data, resolve);
                }
                else {
                    onFail(resp.data, reject);
                }

            }
            else {
                onFail(resp, reject);
            }
        })
    });


};




// WEBPACK FOOTER //
// ./src/utils/request.js